import React, { useMemo } from "react";
import { findScreentone } from "../constants/screentones";

const ScreentoneOverlay = ({ patternKey, width, height, opacity = 0.3, color = "#000000" }) => {
  const pattern = findScreentone(patternKey);

  const patternId = useMemo(
    () => `screentone-${patternKey}-${Math.random().toString(36).substr(2, 6)}`,
    [patternKey]
  );

  if (!pattern || !pattern.svg) return null;

  const size = pattern.patternSize || 8;
  const svgContent = pattern.svg(size);

  return (
    <svg
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 5,
        opacity,
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id={patternId}
          x="0"
          y="0"
          width={size}
          height={size}
          patternUnits="userSpaceOnUse"
        >
          <g
            style={{ color }}
            dangerouslySetInnerHTML={{ __html: svgContent }}
          />
        </pattern>
      </defs>
      <rect width={width} height={height} fill={`url(#${patternId})`} />
    </svg>
  );
};

export default ScreentoneOverlay;
